<div class="navblock">
  <button (click)="openCreateModal()" class="btnadd">{{'Add user'|translate}}</button>
  <div class="inputgroup">
    <input class="searchinput" type="text" placeholder="{{'Find by name' | translate }}" [(ngModel)]="nameFilter"
      (input)="onTermChange($event)" />
  </div>

  <div class="company-filter">
    <p-multiselect [options]="companies" [ngModel]="filter.companyIds" (ngModelChange)="companyFilterChange($event)"
      optionLabel="Name" optionValue="Id" [filter]="true" filterBy="Name" [showClear]="true" [appendTo]="'body'"
      styleClass="objects-company-multiselect" panelStyleClass="objects-company-multiselect-panel"
      [placeholder]="'All companies' | translate"></p-multiselect>
  </div>
</div>
<div class="tablewrap">
  <div class="table">
    <table fixedcols="[0, 8]" id="exporttable">
      <tr>
        <th>
          <switch-all-checkbox [items]="objects | groupFilter: filter" />
        </th>
        <th>{{'Name'|translate}}</th>
        <th>{{'Email'|translate}}</th>
        <th>{{'Role'|translate}}</th>
        <th>{{'Company'|translate}}</th>
        <th>{{'State'|translate}}</th>
        <th>{{'Last login time'|translate}}</th>
        <th>{{'Objects count'|translate}}</th>
        <th>{{'Geozones count'|translate}}</th>
        <th>&nbsp;</th>
      </tr>
      <tr *ngFor="let user of objects | groupFilter : filter | pagesfilter: pageInfoFilter">
        <td>
          <input type="checkbox" [(ngModel)]="user.IsChecked" />
        </td>
        <td>{{user.Name}}</td>
        <td>{{user.Email}}</td>
        <td>{{user.RoleDisplayName() | translate}}</td>
        <td>{{getCompanyName(user)}}</td>
        <td>{{getUserState(user)}}</td>

        <td>{{ user.LoginDate | datetime:'%0D.%0M.%0Y %0h:%0m:%0s' }}</td>

        <td>{{user.ObjectsCount}}</td>
        <td>{{user.GeozonesCount}}</td>
        <td>
          <button class="btn_img btn_edit" title="{{'Edit'|translate}}" (click)="openEditModal(user)"></button>
          <button class="btn_img btn_trush " (click)="deleteObject(user.Id)" title="{{'Delete'|translate}}"></button>
        </td>
      </tr>
    </table>
  </div>
</div>
<app-footer-component (onDeleteSelected)="deleteSelected()" [viewMode]="'print excel pages'"
  (onPageChange)="onPageChange($event)" [items]="objects | groupFilter : filter">
  <div export style="display:inline-block" *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.DATAINFO)">
    <div class="btn_img btn_graygray dropup btn_export-import dropclick">
      <ul>
        <li [routerLink]="['/diagnostics']">{{'Diagnostics'|translate}}</li>
      </ul>
    </div>
  </div>
</app-footer-component>
<template #mgmtDialog></template>